import axios from '../utils/axios';

export default function getSearchedKeywords (adminId, params) {
    return axios.get(`/admin/${adminId}/get-top-searched-keywords`, { params });
}